module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNqclEEOgjAQRUvDHm9AOYFNXGs8AltXyg04Cldgo1tuIHGtCTcQb4AnwBkzJc1AhfqTn4ZJ56Wd6RD0fS+4do+LgmUPVla4Bde3zaHl+wMbAskrWArwUbhVgnOAdSMIADQsFTgW83qBUwA1A4RO0CwE2CCNJ5IUKDwBgvYX35Ns72cs3tMj+Q2OrO9EUheWKsNasNg+ZG00d40dACx8zeJKTkBOlOACrDld0iOyVVGnsiUAVDgBiSgBa5WAu18AzJcTd7RBagaAqiXNQukAXWcAJeabx5ZTV4Tni81NYQUNU+oBMrPTDRACYUe042p8irUZvtGv4N//yUeAAQAzOVxJLyqQ7wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/right.png
// module id = 66
// module chunks = 0